import { render, staticRenderFns } from "./ViewStyle.vue?vue&type=template&id=2307fd8e&scoped=true"
import script from "./ViewStyle.vue?vue&type=script&lang=js"
export * from "./ViewStyle.vue?vue&type=script&lang=js"
import style0 from "./ViewStyle.vue?vue&type=style&index=0&id=2307fd8e&prod&lang=scss&scoped=true"
import style1 from "./ViewStyle.vue?vue&type=style&index=1&id=2307fd8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2307fd8e",
  null
  
)

export default component.exports